import { useRouter } from 'next/router';
import { UiTitle } from 'znanie-uikit';

import LayoutConfines from 'components/layout/LayoutConfines';
import LinkTo from 'components/common/LinkTo';

import ContentCard from 'components/library/ContentCard';

import { ContentType } from 'graphql/types';

import { trackAnalyticsData, AnalyticsEvent } from 'utils/analytics';

import css from './ContentOnMain.module.scss';

interface IProps {
  contents: ContentType[];
}

export default function ContentOnMain(props: IProps) {
  const { contents } = props;

  const router = useRouter();

  const onContentCardClick = async (url: string, item: ContentType) => {
    await router.push(url);
    trackAnalyticsData(AnalyticsEvent.MAIN_CONTENT_ITEM_CLICK, {
      slug: item.slug,
      created: item.created,
      speakers: item.speakers?.map((speaker) => speaker?.id) || [],
    });
  };

  const handleAllContentClick = () => {
    trackAnalyticsData(AnalyticsEvent.MAIN_CONTENT_SHOW_ALL_CLICK);
  };

  return (
    <div className={css.block}>
      <LayoutConfines>
        <div className={css.header}>
          <UiTitle size="big" as="h2">
            Видеозаписи
          </UiTitle>
          <LinkTo href="/library" onClick={handleAllContentClick} />
        </div>
        <div className={css.wrapper}>
          <div className={css.content}>
            {contents.map((content) => (
              <div key={`content_card_${content.id}`} className={css.item}>
                <ContentCard item={content} onClick={onContentCardClick} />
              </div>
            ))}
          </div>
        </div>
      </LayoutConfines>
    </div>
  );
}
